module.exports = __webpack_public_path__ + "static/media/log-out-icon.cc76ad0d.svg";